var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep62(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 229,
    viewBox: "0 0 332 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.707 0.292893C324.317 -0.0976311 323.683 -0.0976311 323.293 0.292893L316.929 6.65685C316.538 7.04738 316.538 7.68054 316.929 8.07107C317.319 8.46159 317.953 8.46159 318.343 8.07107L324 2.41421L329.657 8.07107C330.047 8.46159 330.681 8.46159 331.071 8.07107C331.462 7.68054 331.462 7.04738 331.071 6.65685L324.707 0.292893ZM314 47.4216H11V49.4216H314V47.4216ZM0 58.4216V187H2V58.4216H0ZM11 198H178V196H11V198ZM325 38.4216V1H323V38.4216H325ZM187 207V229H189V207H187ZM178 198C182.971 198 187 202.029 187 207H189C189 200.925 184.075 196 178 196V198ZM0 187C0 193.075 4.92487 198 11 198V196C6.02944 196 2 191.971 2 187H0ZM11 47.4216C4.92486 47.4216 0 52.3464 0 58.4216H2C2 53.451 6.02943 49.4216 11 49.4216V47.4216ZM314 49.4216C320.075 49.4216 325 44.4967 325 38.4216H323C323 43.3921 318.971 47.4216 314 47.4216V49.4216Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep62);
export default __webpack_public_path__ + "static/media/laptop_step_6_2.a1a496a21b62b378bbc428613c266e04.svg";
export { ForwardRef as ReactComponent };